// extracted by mini-css-extract-plugin
export default {"fullHeight":"styles-module__fullHeight__src-labstep-web-core-CodeMirror-_iYb8p"};